export default __webpack_public_path__ + "assets/magnifier-7f2845355495c02cd11dfe27bc0a813d.svg";